import React from 'react'
import PropTypes from 'prop-types'
// import { ShareButtons, generateShareIcon } from 'react-share';

// const { FacebookShareButton } = ShareButtons;
// const FacebookIcon = generateShareIcon('facebook');

class FBShare extends React.Component {
  render() {
    return (
      <div className="share">
        {/* <FacebookShareButton
          url={this.props.url}
          title={this.props.title}
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton> */}
      </div>
    )
  }
}

FBShare.propTypes = {
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default FBShare
